import { combineReducers } from 'redux';
import auth from './auth';
import map from './map';
import tools from './tools';
import video from './video';

const rootReducer = combineReducers({
  auth,
  map,
  tools,
  video,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js